module.exports = __webpack_public_path__ + "media/images/flag-fe9917b93d24da412a4400f8004bf819.svg";